<template>
  <div class="container">
    <v-bottom-navigation v-show="alert" fixed>
      <v-btn>
        <v-chip
          class="ma-2"
          close
          color="primary"
          text-color="white"
          @click:close="cancelaCopia"
          >Está copiando o reprogramando un turno</v-chip
        >
      </v-btn>
    </v-bottom-navigation>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Agenda Diaria</v-toolbar-title>
      </v-toolbar>
      <v-alert
        v-if="muestraObservaciones && observacionesProf"
        class="obs-alert"
        color="purple"
        dark
        dismissible
        outlined
      >
        <div><strong>Observaciones del profesional:</strong></div>
        <div>{{ observacionesProf }}</div>
      </v-alert>
      <v-row class="ml-2 mr-1 mb-1 first-row">
        <v-col
          cols="12"
          md="4"
          sm="4"
          :class="`${listaTurnos.length ? 'mb-0 pb-0' : 'mb-0'} mt-4`"
        >
          <v-select
            :items="servicios"
            item-text="nomServicio"
            item-value="servicio"
            menu-props="auto"
            label="Servicio"
            hide-details
            prepend-icon="mdi-account"
            v-model="servicio"
            @change="buscarProfesionales"
            :disabled="isLoading"
            class="mt-3"
            ref="servicio"
            no-data-text="No hay Servicios configurados"
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="4"
          :class="`${listaTurnos.length ? 'mb-0 pb-0' : 'mb-0'} mt-4`"
        >
          <v-select
            :items="profs"
            item-text="nombreProfesional"
            item-value="idProfesional"
            menu-props="auto"
            label="Profesional"
            hide-details
            prepend-icon="mdi-account"
            v-model="prof"
            :disabled="isLoading"
            class="mt-3"
            ref="vselect"
            no-data-text="No hay Profesionales configurados"
          ></v-select>
        </v-col>
        <v-col
          v-if="listaTurnos.length"
          :class="`${listaTurnos.length ? 'mb-0 pb-0' : 'mb-2'} estados-col`"
          cols="12"
          md="4"
          sm="4"
        >
          <div class="estados-container">
            <v-row class="estados-turnos"
              >Total turnos del día:
              <span class="ml-1"> {{ turnosTotales }}</span>
            </v-row>
            <v-row class="estados-turnos"
              >Pacientes en espera:
              <span class="ml-1"> {{ turnosEspera }}</span>
            </v-row>
            <v-row class="estados-turnos"
              >Pacientes atendidos:
              <span class="ml-1"> {{ turnosAtendidos }}</span></v-row
            >
          </div>
        </v-col>
      </v-row>
      <v-toolbar flat class="pt-2">
        <v-row>
          <v-btn
            max-width="40px"
            min-width="40px"
            class="ml-4 mr-2"
            @click="retrocederSemana"
            tile
            color="blue"
            dark
          >
            <v-icon large>mdi-arrow-left-bold</v-icon>
          </v-btn>

          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFormatted"
                :label="dayWeek"
                @blur="date = date"
                readonly
                v-on="on"
                class="shrink"
                style="width: 88px"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu2 = false"
              locale="es-ar"
              :first-day-of-week="1"
              @change="armarTurnos"
            ></v-date-picker>
          </v-menu>

          <v-btn
            class="ml-2"
            max-width="40px"
            min-width="40px"
            @click="avanzarSemana"
            tile
            color="blue"
            dark
          >
            <v-icon large>mdi-arrow-right-bold</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-row>
      </v-toolbar>

      <v-card-title class="mt-0 pt-0">
        <v-row class="mt-0 pt-0 mb-0 pb-0">
          <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0 refresco-orden">
            <v-checkbox
              class="refresco-checkbox"
              v-model="refrescarPantalla"
              label="Refresco Automático de Pantalla"
              color="primary"
              dense
            ></v-checkbox>
            <v-slider
              class="tiempo-cronometro"
              v-model="tiempoCronometro"
              label="Tiempo Temporizador"
              thumb-color="green"
              thumb-label="always"
              min="1"
              max="60"
            ></v-slider>
            <div class="acciones-turnos">
              <v-btn
                v-if="
                  habilitaLLamarSecretariaIds.includes(
                    $store.state.usuario.institucion.idInstitucion,
                  ) && listaTurnos.length
                "
                class="ml-2 mr-2"
                tile
                color="primary"
                dark
                @click="llamarSecretaria"
              >
                Llamar Secretaria
              </v-btn>
              <v-btn
                v-if="$store.state.usuario.institucion.utilizaLlamador"
                class="ml-2 mr-2"
                @click="verConsultorio"
                tile
                color="indigo"
                dark
              >
                Consultorio
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-2 mr-2"
                    @click="mostrarOrdenLLegada"
                    tile
                    color="warning"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Ver órden de llegada turnos del día
                  </v-btn>
                </template>
                <span>Configurar consultorio del profesional</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar turnos en el día"
              single-line
              hide-details
              dense=""
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="this.listaTurnos"
        :search="search"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        :hide-default-footer="true"
        :loading="isLoading"
        locale="es-ar"
        item-key="id"
        show-expand
        class="elevation-1 mytable"
        :disable-sort="true"
        :items-per-page="500"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td
            v-show="
              item.paciente != 'Disponible' &&
              item.hora != 'Feriado' &&
              item.observacionesTurno != 'Cancelación'
            "
            :colspan="headers.length"
            style="background-color: #e3e3e3"
          >
            <strong
              >{{
                $store.state.usuario.institucion.esEmpresa
                  ? "Sede"
                  : "Obra Social"
              }}:</strong
            >
            {{ item.obraSocial }}
            <br />
            <strong>Direccion:</strong>
            {{ item.direccion }}
            <br />
            <strong>Mail:</strong>
            {{ item.mail }}
            <br />
            <strong>Telefono:</strong>
            {{ item.telefono }}
            <br />
            <strong>Celular:</strong>
            {{ item.celular }}
            <br />
            <strong>Observaciones del Paciente:</strong>
            {{ item.observacionesPaciente }}
            <br />
            <strong>Observaciones del Turno:</strong>
            {{ item.observacionesTurno }}
          </td>
        </template>

        <template v-slot:item.hora="{ item }">
          <v-chip
            :color="
              getColor(
                item.hora,
                item.paciente,
                item.entreTurno,
                item.estadoTurno,
                item.observacionesTurno,
                item.idObraSocial,
              )
            "
            dark
            >{{ item.hora }}</v-chip
          >
        </template>

        <template v-slot:item.paciente="{ item }">
          <v-chip
            :color="
              getColorPaciente(
                item.hora,
                item.paciente,
                item.entreTurno,
                item.estadoTurno,
                item.observacionesTurno,
                item.idObraSocial,
              )
            "
            dark
          >
            {{ item.paciente }}
            <v-avatar
              class="ml-2"
              v-if="item.cantIntervalos > 1"
              color="#541402"
              size="32"
            >
              <span class="white--text">{{ item.cantIntervalos }}</span>
            </v-avatar>
            <v-tooltip top v-if="item.fechaFinAtencion">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="confirmation-icon ml-2" v-on="on" v-bind="attrs">mdi-flag-checkered</v-icon>
              </template>
              <span>Atención Finalizada</span>
            </v-tooltip>
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="
                  item.paciente == 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.hora != 'Cancelación'
                "
                small
                rounded
                color="green"
                dark
                @click.stop="nuevoTurno(item, 0)"
              >
                <v-icon class="mr-2" dark left> mdi-calendar </v-icon>Nuevo
                Turno
              </v-btn>
            </template>
            <span>Nuevo Turno</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1
                "
                medium
                color="purple"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="editarTurno(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar Turno</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                class="mr-3"
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1 &&
                  ($store.state.usuario.institucion.idInstitucion !== 195 ||
                    $store.state.usuario.roles.some((rol) =>
                      [1, 12].includes(rol.idRol),
                    ))
                "
                v-on="on"
                color="red"
                v-bind="attrs"
                @click.stop="deleteItem(item)"
                >mdi-delete</v-icon
              >
            </template>
            <span>Eliminar Turno</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                class="mr-3"
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1
                "
                v-on="on"
                color="grey"
                v-bind="attrs"
                @click.stop="nuevoTurno(item, 1)"
                >mdi-calendar-multiple</v-icon
              >
            </template>
            <span>Entre Turno</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                class="mr-3"
                color="blue"
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1 &&
                  (roles.some((o) => o.idRol === 1) ||
                    roles.some((o) => o.idRol === 4))
                "
                v-on="on"
                v-bind="attrs"
                @click.stop="historiaClinica(item)"
                >mdi-heart-pulse</v-icon
              >
            </template>
            <span>Historia Clínica</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                class="mr-3"
                color="#d35400"
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1 &&
                  (roles.some((o) => o.idRol === 1) ||
                    roles.some((o) => o.idRol === 5))
                "
                v-on="on"
                v-bind="attrs"
                @click.stop="cobrar(item)"
                >mdi-currency-usd</v-icon
              >
            </template>
            <span>Cobro</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1
                "
                medium
                color="black"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click="copiarReprogramar(item)"
                >mdi-content-duplicate</v-icon
              >
            </template>
            <span>Copiar / Reprogramar Turno</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  item.esVideoLlamada === false &&
                  item.paciente !== 'Disponible' &&
                  item.hora !== 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar !== 1 &&
                  utilizaLlamador === true &&
                  (($store.state.usuario.institucion.idInstitucion === 195 &&
                    (item.estadoTurno === 2 || item.estadoTurno === 3)) ||
                    ($store.state.usuario.institucion.idInstitucion !== 195 &&
                      item.estadoTurno == '2')) &&
                  (roles.some((o) => o.idRol === 1) ||
                    roles.some((o) => o.idRol === 4)) &&
                  esDeHoy(item)
                "
                medium
                color="indigo"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click="llamarPaciente(item)"
                >mdi-bullhorn</v-icon
              >
            </template>
            <span>Llamar Paciente</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  item.esVideoLlamada == true &&
                  (roles.some((o) => o.idRol === 1) ||
                    roles.some((o) => o.idRol === 4)) &&
                  esDeHoy(item)
                "
                medium
                color="indigo"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click="iniciarVideoConsulta(item)"
                >mdi-video</v-icon
              >
            </template>
            <span>Iniciar Videoconsulta</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="chequearEnviarDatosTurno(item) && copiar != 1"
                medium
                color="green"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click="enviarDatosTurno(item)"
                >mdi-whatsapp</v-icon
              >
            </template>
            <span>Enviar Datos Turno</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  item.paciente != 'Disponible' &&
                  item.hora != 'Feriado' &&
                  item.observacionesTurno != 'Cancelación' &&
                  copiar != 1 &&
                  item.estadoTurno !== 3 &&
                  !activeTimers[item.idTurno]
                "
                medium
                color="black"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click="startTimer(item.idTurno)"
                >mdi-timer-outline</v-icon
              >
            </template>
            <span>Iniciar Temporizador</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  puedeFinalizarAtencion(
                    $store.state.usuario.institucion.trackingHabilitado,
                    item.estadoTurno,
                    copiar,
                    item.fechaFinAtencion,
                  )
                "
                medium
                color="green"
                class="mr-3"
                v-on="on"
                v-bind="attrs"
                @click.stop="finalizarAtencion(item)"
                >mdi-flag-checkered</v-icon
              >
            </template>
            <span>Finalizar Atención</span>
          </v-tooltip>
          <v-chip
            v-show="
              item.paciente != 'Disponible' &&
              item.hora != 'Feriado' &&
              item.observacionesTurno != 'Cancelación' &&
              copiar != 1 &&
              item.estadoTurno !== 3 &&
              activeTimers[item.idTurno]
            "
            :key="tick"
            class="ma-2"
            :close="!(reactiveTimers[item.idTurno] === 0)"
            :color="reactiveTimers[item.idTurno] === 0 ? 'red' : 'green'"
            outlined
            @click:close="stopTimer(item.idTurno)"
          >
            ⏱️
            {{
              reactiveTimers[item.idTurno] === 0
                ? "TIEMPO CUMPLIDO"
                : formatTime(reactiveTimers[item.idTurno])
            }}
          </v-chip>
        </template>
        <span>Detener Temporizador</span>
      </v-data-table>
      <v-alert
        color="blue"
        dark
        outlined
        v-if="listaTurnos.length == 0 && !isLoading"
        class="mb-0 mt-2"
        >No hay agenda configurada para este día. <br />
        <br />
        <v-btn
          v-if="
            roles.some((o) => o.idRol === 1) || roles.some((o) => o.idRol === 3)
          "
          color="warning"
          @click="
            $router.push({
              name: 'Cronogramas',
              params: { idProfesional: prof },
            })
          "
          >Configurar Cronograma</v-btn
        >
      </v-alert>
      <v-card-title>
        <v-btn
          color="success"
          @click="mostrarCronogramas"
          dark
          class="mb-2"
          v-on="on"
          >Ver Cronogramas Vigentes</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="mostrarColores"
          dark
          class="mb-2"
          v-on="on"
          >Ver reseña de íconos y colores</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="error" @click="salir" dark class="mb-2" v-on="on"
          >Salir</v-btn
        >
      </v-card-title>
      <NuevoTurno
        :visible="showNuevoTurno"
        :dia="dateFormatted"
        :hora="horaTurno"
        :idProfesional="prof"
        :tiempoTurno="editedItem.tiempoTurno"
        :entreTurno="this.entreTurno"
        :tipoTurno="editedItem.tipoTurno"
        @close="showNuevoTurno = false"
        @turnoRegistrado="turnoRegistrado"
      ></NuevoTurno>
      <EditarTurno
        :visible="showEditarTurno"
        :dia="dateFormatted"
        :hora="editedItem.hora"
        :idProfesional="prof"
        :tiempoTurno="editedItem.tiempoTurno"
        :idTurno="editedItem.idTurno"
        :observacionesPaciente="editedItem.observacionesPaciente"
        :tipoCronograma="editedItem.tipoTurno"
        @close="showEditarTurno = false"
        @turnoModificado="turnoModificado"
      ></EditarTurno>
      <Colores :visible="showColores" @close="showColores = false"></Colores>
      <VerPacientesEnEspera
        v-if="showVerPacientesEnEspera"
        :visible="showVerPacientesEnEspera"
        :listaTurnos="listaTurnosOrden"
        :prof="prof"
        :esVistaDiaria="true"
        :dateFormatted="dateFormatted"
        :nombreProfesional="$refs.vselect.selectedItems[0].nombreProfesional"
        @close="showVerPacientesEnEspera = false"
      />
      <VerCronogramas
        :visible="showCronogramas"
        :prof="prof"
        @close="showCronogramas = false"
      ></VerCronogramas>
      <VerConsultorio
        v-if="showVerConsultorio"
        :visible="showVerConsultorio"
        :nombreProfesional="$refs.vselect.selectedItems[0].nombreProfesional"
        :idProfesional="prof"
        @close="showVerConsultorio = false"
      ></VerConsultorio>
      <NuevoCobro
        :visible="showNuevoCobro"
        :idTurno="editedItem.idTurno"
        :estadoTurno="editedItem.estadoTurno"
        :pacienteTurno="editedItem.paciente"
        :idProfesional="prof"
        :idPacienteTurno="editedItem.idPaciente"
        :celular="editedItem.celular"
        :nombrePaciente="editedItem.paciente"
        @recargarLista="armarTurnos"
        @close="cierraNuevoCobro()"
      ></NuevoCobro>
    </v-card>
  </div>
</template>
<style scoped lang="scss">
.tiempo-cronometro {
  margin-top: 1rem;
  margin-right: 0.5rem;
}
.obs-alert {
  margin-bottom: 0;
}

.acciones-turnos {
  display: flex;
  gap: 0.3rem;
  flex-wrap: wrap;
}
.refresco-orden {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
:deep(.refresco-orden) {
  .v-input--checkbox {
    flex: 1 0 auto !important;
  }
}
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.first-row {
  align-items: stretch;
}

.estados-col {
  display: flex;
  justify-content: flex-end;
}

.estados-container {
  width: fit-content;
  border: 1px solid green;
  border-radius: 20px;
  text-align: center;
  padding: 0.4rem;
}

.estados-turnos {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  justify-content: flex-end;
  font-size: 18px;
  font-weight: 600;
  span {
    color: red;
  }
  @media screen and (max-width: 599px) {
    font-size: 16px;
  }
}

.prof-sin-turno {
  @media screen and (max-width: 599px) {
    padding-top: 0;
  }
}
</style>

<script>
import EditarTurno from "../Turnos/EditarTurno.vue";
import NuevoTurno from "../Turnos/NuevoTurno.vue";
import Colores from "../Turnos/Colores.vue";
import NuevoCobro from "../Caja/NuevoCobro.vue";
import VerCronogramas from "../Turnos/VerCronogramasActivos.vue";
import axios from "../../axios-auth.js";
import router from "../../router/index.js";
import { puedeFinalizarAtencion } from "../../utils/utils.js";
import VerPacientesEnEspera from "./VerPacientesEnEspera.vue";
import VerConsultorio from "./VerConsultorio.vue";

export default {
  name: "GestionTurnos",

  data: (vm) => ({
    dialog: false,
    alert: false,
    utilizaLlamador: false,
    roles: [],
    showNuevoTurno: false,
    showEditarTurno: false,
    showColores: false,
    showCronogramas: false,
    showNuevoCobro: false,
    valid: true,
    copiar: 0,
    name: "",
    refrescarPantalla: null,
    interval: null,
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
    isLoading: false,
    expanded: [],
    singleExpand: false,
    search: "",
    headersLength: {
      type: Number,
    },
    editedIndex: -1,
    editedItem: {
      hora: "",
      paciente: "",
    },
    defaultItem: {
      hora: "",
      paciente: "",
    },
    date: vm.toISOLocal(new Date()),
    dateFormatted: vm.formatDate(vm.toISOLocal(new Date())),
    menu: false,
    modal: false,
    menu2: false,
    dayWeek: "",
    prof: "",
    profs: [],
    servicio: null,
    servicios: [],
    diaSemana: null,
    on: null,
    horaTurno: "",
    entreTurno: "",
    listaTurnos: [],
    listaTurnosOrden: [],
    itemCopia: {
      idTurno: null,
      tiempoTurno: null,
      cantIntervalos: null,
      idProfesional: null,
      estadoTurno: null,
    },
    showVerPacientesEnEspera: false,
    showVerConsultorio: false,
    activeTimers: {},
    tick: 0,
    intervalId: null,
    observacionesProf: "",
    tiempoCronometro: 20,
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.determinarDayWeek();
    },
    refrescarPantalla() {
      this.refrescar();
    },
    prof: {
      handler(val) {
        if (val) {
          this.armarTurnos();
          if (this.muestraObservaciones) {
            this.buscarObservacionesProf(val);
          }
        }
      },
    },
  },
  computed: {
    muestraObservaciones() {
      return [436].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      );
    },
    habilitaLLamarSecretariaIds() {
      return [323];
    },
    headers() {
      return [291, 464].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      )
        ? [
            {
              text: "Hora",
              align: "start",
              filterable: false,
              value: "hora",
            },
            { text: "Paciente", value: "paciente" },
            { text: "Observaciones Turno", value: "observacionesTurno" },
            { text: "Acciones", value: "actions", sortable: false },
          ]
        : [
            {
              text: "Hora",
              align: "start",
              filterable: false,
              value: "hora",
            },
            { text: "Paciente", value: "paciente" },
            { text: "Acciones", value: "actions", sortable: false },
          ];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Turno" : "Editar Turno";
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    turnosTotales() {
      return this.listaTurnos.filter((turno) => turno.idPaciente > 0).length;
    },
    turnosEspera() {
      return this.listaTurnos.filter(
        (turno) => turno.idPaciente > 0 && turno.estadoTurno === 2,
      ).length;
    },
    turnosAtendidos() {
      return this.listaTurnos.filter(
        (turno) => turno.idPaciente > 0 && turno.estadoTurno === 3,
      ).length;
    },
    reactiveTimers() {
      this.tick; // Dependencia reactiva
      const result = {};
      for (const turnoId in this.activeTimers) {
        result[turnoId] = this.calculateRemainingTime(turnoId);
      }
      return result;
    },
  },
  created() {
    this.servicios = [
      ...this.$store.state.usuario.profesionales.sort((a, b) =>
        a.nomServicio.localeCompare(b.nomServicio),
      ),
    ];

    this.servicios.unshift({
      nomServicio: "TODOS",
      servicio: -1,
    });
    this.servicio = this.servicios[0].servicio;

    this.profs = [...this.$store.state.usuario.profesionales].sort((a, b) =>
      a.nombreProfesional.localeCompare(b.nombreProfesional),
    );

    if (this.$route.params.idProfesional) {
      this.prof = this.$route.params.idProfesional;
    } else {
      if (this.$store.state.indexProf != 0) {
        this.prof = this.$store.state.indexProf;
      } else {
        this.prof = this.profs[0].idProfesional;
      }
    }

    this.determinarDayWeek();
    this.utilizaLlamador =
      this.$store.state.usuario.institucion.utilizaLlamador;
    this.roles = this.$store.state.usuario.roles;
  },
  mounted() {
    this.refrescarPantalla = [195, 291, 464].includes(
      this.$store.state.usuario.institucion.idInstitucion,
    )
      ? true
      : false;

    const stored = localStorage.getItem("oftalmoTimers");
    const today = new Date().toISOString().slice(0, 10);

    if (stored) {
      const timers = JSON.parse(stored);

      // Limpiar timers de días anteriores
      for (const id in timers) {
        if (timers[id].date !== today) {
          delete timers[id];
        }
      }

      this.activeTimers = { ...timers };
      this.saveTimers();
    }

    // Actualización cada segundo
    this.intervalId = setInterval(() => {
      this.tick++;
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    if (this.intervalId) clearInterval(this.intervalId);
  },
  methods: {
    async buscarObservacionesProf(idProfesional) {
      try {
        const { data: observaciones } = await axios.get(
          "/Profesional/BuscarObservacionesProf",
          {
            params: {
              idProfesional,
            },
          },
        );
        this.observacionesProf = observaciones;
      } catch (error) {
        console.log(error);
        this.observacionesProf = "";
      }
    },
    startTimer(turnoId) {
      const now = Date.now();
      const today = new Date().toISOString().slice(0, 10);
      this.$set(this.activeTimers, turnoId, {
        startTime: now,
        duration: this.tiempoCronometro * 60,
        date: today,
      });
      this.saveTimers();
    },
    stopTimer(turnoId) {
      this.$delete(this.activeTimers, turnoId);
      this.saveTimers();
    },
    calculateRemainingTime(turnoId) {
      const timer = this.activeTimers[turnoId];
      if (!timer) return 0;
      const elapsed = (Date.now() - timer.startTime) / 1000;
      const remaining = timer.duration - elapsed;
      return Math.max(0, remaining);
    },
    remainingTime(turnoId) {
      this.tick; // Esto hace que el método sea reactivo al cambio de tick
      const timer = this.activeTimers[turnoId];
      if (!timer) return 0;
      const elapsed = (Date.now() - timer.startTime) / 1000;
      const remaining = timer.duration - elapsed;
      return Math.max(0, remaining);
    },
    formatTime(seconds) {
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return `${m.toString().padStart(2, "0")}:${s
        .toString()
        .padStart(2, "0")}`;
    },
    saveTimers() {
      localStorage.setItem("oftalmoTimers", JSON.stringify(this.activeTimers));
    },
    mostrarOrdenLLegada() {
      this.listaTurnosOrden = [...this.listaTurnos];

      if (
        !this.listaTurnosOrden.some(
          (turno) => turno.estadoTurno === 2 || turno.estadoTurno === 3,
        )
      ) {
        this.showAlert({
          icon: "info",
          title: "No hay pacientes en espera o atendidos aún el día de hoy",
          vm: this,
        });
        return;
      }

      this.listaTurnosOrden = this.listaTurnosOrden
        .filter((turno) => turno.fechaEspera || turno.fechaAtendido)
        .sort((a, b) => {
          const dateA = a.fechaEspera
            ? new Date(a.fechaEspera).getTime()
            : Infinity;
          const dateB = b.fechaEspera
            ? new Date(b.fechaEspera).getTime()
            : Infinity;
          return dateA - dateB;
        });
      this.showVerPacientesEnEspera = true;
    },
    buscarProfesionales() {
      if (this.servicio === -1) {
        this.profs = [...this.$store.state.usuario.profesionales].sort((a, b) =>
          a.nombreProfesional.localeCompare(b.nombreProfesional),
        );
      } else {
        this.profs = [...this.$store.state.usuario.profesionales]
          .filter((prof) => prof.servicio === this.servicio)
          .sort((a, b) =>
            a.nombreProfesional.localeCompare(b.nombreProfesional),
          );
      }
      this.prof = this.profs[0].idProfesional;
    },
    enviarDatosTurno(item) {
      const datosTurno = {
        idTurno: item.idTurno,
        fechaTurno: this.dateFormatted,
        horaTurno: item.hora,
      };
      let self = this;
      axios
        .get("/Turnos/EnviarDatosTurno", {
          params: {
            idTurno: datosTurno.idTurno,
            fechaTurno: datosTurno.fechaTurno,
            horaTurno: datosTurno.horaTurno,
          },
        })
        .then((response) => {
          self.showAlert({
            icon: "success",
            title: "Datos enviados exitosamente",
            vm: self,
          });
        })
        .catch((error) => {});
    },
    chequearEnviarDatosTurno(item) {
      if (
        (this.$store.state.usuario.institucion.idInstitucion === 114 ||
          this.$store.state.usuario.institucion.idInstitucion === 270) &&
        item.celular
      ) {
        return true;
      }
      return item.celular && item.celular.toString().length == 10;
    },
    salir() {
      router.push("/Home");
    },
    esDeHoy(item) {
      var desdeParte = this.dateFormatted.split("/");
      var desde = new Date(desdeParte[2], desdeParte[1] - 1, desdeParte[0]);
      var hoyParte = this.formatDate(
        this.toISOLocal(new Date()).substr(0, 10),
      ).split("/");
      var hoy = new Date(hoyParte[2], hoyParte[1] - 1, hoyParte[0]);

      if (desde.toString() == hoy.toString()) {
        return true;
      } else {
        return false;
      }
    },
    historiaClinica(item) {
      this.$store.dispatch("setDni", item.dni);
      this.$store.dispatch("setRutaSalidaHC", 1);
      this.$store.dispatch("setIndexProf", this.prof);
      if (
        ((this.$store.state.usuario.institucion.idInstitucion !== 195 &&
          item.estadoTurno != 3) ||
          item.estadoTurno == 2) &&
        !this.$store.state.usuario.institucion.esEmpresa
      ) {
        this.$swal({
          title: "Marcar como Atendido",
          text: "¿Desea marcar el turno como atendido?",
          icon: "success",
          type: "success",
          showCancelButton: true,
          background: "#ececec",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value == true) {
            axios.get("/Turnos/Atendido?", {
              params: {
                idTurno: item.idTurno,
              },
            });
          }
        });
      }
      router.push("/HistoriasClinicas");
    },
    iniciarVideoConsulta(item) {
      this.$store.dispatch("setVideollamada", true);
      this.$store.dispatch("setLinkVideollamada", item.linkVideoLlamada);
      this.$store.dispatch("setNombrePaciente", item.paciente);
      this.$store.dispatch(
        "setNombreProfesional",
        this.$refs.vselect.selectedItems[0].nombreProfesional,
      );
      this.$store.dispatch("setDni", item.dni);
      this.$store.dispatch("setRutaSalidaHC", 1);
      this.$store.dispatch("setIndexProf", this.prof);
      if (
        ((this.$store.state.usuario.institucion.idInstitucion !== 195 &&
          item.estadoTurno != 3) ||
          item.estadoTurno == 2) &&
        !this.$store.state.usuario.institucion.esEmpresa
      ) {
        this.$swal({
          title: "Marcar como Atendido",
          text: "¿Desea marcar el turno como atendido?",
          icon: "success",
          type: "success",
          showCancelButton: true,
          background: "#ececec",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value == true) {
            axios.get("/Turnos/Atendido?", {
              params: {
                idTurno: item.idTurno,
              },
            });
          }
        });
      }
      if (this.isMobile() == false) router.push("/HistoriasClinicas");
      else router.push("/VideoLlamada");
    },
    determinarDayWeek() {
      switch (new Date(this.date).getDay()) {
        case 0:
          this.dayWeek = "Lunes";
          break;
        case 1:
          this.dayWeek = "Martes";
          break;
        case 2:
          this.dayWeek = "Miércoles";
          break;
        case 3:
          this.dayWeek = "Jueves";
          break;
        case 4:
          this.dayWeek = "Viernes";
          break;
        case 5:
          this.dayWeek = "Sábado";
          break;
        case 6:
          this.dayWeek = "Domingo";
          break;
      }
    },
    retrocederSemana() {
      let dias = 1000 * 60 * 60 * 24 * 1;
      let resta = new Date(this.date).getTime();
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = this.formatDate(this.toISOLocal(new Date(resta)));
      this.armarTurnos();
    },
    avanzarSemana() {
      let dias = 1000 * 60 * 60 * 24 * 2;
      let resta = new Date(this.date).getTime() + dias;
      this.date = this.toISOLocal(new Date(resta));
      this.dateFormatted = this.formatDate(this.toISOLocal(new Date(resta)));
      this.armarTurnos();
    },
    cobrar(item) {
      this.editedIndex = this.listaTurnos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showNuevoCobro = true;
    },
    allowedDates: (val) => new Date(val).getDay() === 0,
    cierraNuevoCobro() {
      this.showNuevoCobro = false;
    },
    refrescar() {
      if (this.refrescarPantalla === true) {
        this.interval = setInterval(
          () => this.armarTurnos(),
          this.$store.state.usuario.institucion.tiempoRefresco * 1000,
        );
      } else {
        clearInterval(this.interval);
      }
    },
    copiarReprogramar(item) {
      this.copiar = 1;
      this.alert = !this.alert;
      this.itemCopia.tiempoTurno = item.tiempoTurno;
      this.itemCopia.cantIntervalos = item.cantIntervalos;
      this.itemCopia.idTurno = item.idTurno;
      this.itemCopia.idProfesional = item.idProfesional;
      this.itemCopia.estadoTurno = item.estadoTurno;
    },
    cancelaCopia() {
      this.alert = !this.alert;
      this.copiar = 0;
      this.itemCopia.tiempoTurno = null;
      this.itemCopia.cantIntervalos = null;
      this.itemCopia.idTurno = null;
      this.itemCopia.idProfesional = null;
    },
    async armarTurnos() {
      this.isLoading = true;
      this.$loading(true);
      const turnosData = {
        idProfesional: this.prof,
        fecha: this.date,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };

      try {
        const response = await axios.get("/Turnos/ArmarTurnosOptimizado?", {
          params: {
            idProfesional: turnosData.idProfesional,
            fecha: turnosData.fecha,
            idInstitucion: turnosData.idInstitucion,
          },
        });
        this.listaTurnos = response.data;
        this.isLoading = false;
        this.$loading(false);
      } catch (error) {
        this.isLoading = false;
        this.$loading(false);
      }
    },
    puedeFinalizarAtencion(
      trackingHabilitado,
      estadoTurno,
      copiar,
      fechaFinAtencion,
    ) {
      return puedeFinalizarAtencion(
        trackingHabilitado,
        estadoTurno,
        copiar,
        fechaFinAtencion,
      );
    },
    finalizarAtencion(item) {
      let self = this;
      this.$swal({
        title: "Finalizar Atención",
        text: "¿Desea marcar la atención de este turno como finalizada?",
        icon: "question",
        type: "question",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true) {
          axios
            .get("/Turnos/FinalizarAtencion?", {
              params: {
                idTurno: item.idTurno,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Atención finalizada",
                vm: self,
              });
              self.armarTurnos();
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "No se pudo finalizar la atención",
                vm: self,
              });
            });
        }
      });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    getColor(
      hora,
      paciente,
      entreTurno,
      estadoTurno,
      observacionesTurno,
      idObraSocial,
    ) {
      if (hora === "Feriado" || observacionesTurno === "Cancelación")
        return "red";
      else {
        if (paciente === "Disponible") return "green";
        else {
          if (estadoTurno === 1) {
            if (idObraSocial == 162 || idObraSocial == 91) {
              return "black";
            } else {
              if (entreTurno === 1) return "grey";
              else return "blue";
            }
          } else {
            if (estadoTurno === 2) return "orange";
            else return "purple";
          }
        }
      }
    },
    getColorPaciente(
      hora,
      paciente,
      entreTurno,
      estadoTurno,
      observacionesTurno,
      idObraSocial,
    ) {
      if (hora === "Feriado" || observacionesTurno === "Cancelación")
        return "red";
      else {
        if (paciente === "Disponible") return "green";
        else {
          if (estadoTurno === 1) {
            if (idObraSocial == 162 || idObraSocial == 91) return "black";
            else {
              if (entreTurno === 1) return "grey";
              else return "blue";
            }
          } else {
            if (estadoTurno === 2) return "orange";
            else return "purple";
          }
        }
      }
    },
    editarTurno(item) {
      this.editedIndex = this.listaTurnos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarTurno = true;
    },
    nuevoTurno(item, val) {
      var desdeParte = this.dateFormatted.split("/");
      var desde = new Date(desdeParte[2], desdeParte[1] - 1, desdeParte[0]);
      var hoyParte = this.formatDate(
        this.toISOLocal(new Date()).substr(0, 10),
      ).split("/");
      var hoy = new Date(hoyParte[2], hoyParte[1] - 1, hoyParte[0]);
      if (desde < hoy) {
        this.$swal({
          title: "Fecha menor al día de hoy",
          text: "Cuidado, la fecha del turno es menor a la fecha actual. ¿Desea continuar igual?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.dismiss == "cancel") {
            return;
          } else {
            this.continuarNuevoTurno(item, val);
          }
        });
      } else {
        this.continuarNuevoTurno(item, val);
      }
    },
    continuarNuevoTurno(item, val) {
      if (this.copiar == 0) {
        this.editedIndex = this.listaTurnos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (val === 0) {
          this.horaTurno = this.editedItem.hora;
          this.entreTurno = 0;
          this.showNuevoTurno = true;
        } else {
          let self = this;
          axios
            .get("/Turnos/ChequearCantMaxEt?", {
              params: {
                fecha: self.dateFormatted,
                idProfesional: self.prof,
              },
            })
            .then((response) => {
              if (response.data == "ok") {
                const cadena = this.obtenerUltimoEntreTurno(
                  this.editedItem.hora,
                );

                if (cadena) {
                  self.$swal.fire({
                    icon: "warning",
                    title: "Ya hay entreturnos en este horario",
                    html:
                      "El último entreturno dado en este rango es el de las <b>" +
                      cadena.ultimaHora +
                      "</b>.<br><br>Para agregar otro, dé el entreturno parándose sobre el entreturno de las <b>" +
                      cadena.ultimaHora +
                      "</b> (el nuevo quedará a las " +
                      cadena.proximaHoraLibre +
                      ") en lugar del turno original.",
                    background: "#ececec",
                    confirmButtonText: "Entendido",
                  });
                  return;
                }

                this.horaTurno = this.calcularHora(this.editedItem.hora);
                this.entreTurno = 1;
                this.showNuevoTurno = true;
              } else {
                self.showAlert({
                  icon: "error",
                  title:
                    "Supera la cantidad máxima de entre turnos diarios establecida para el profesional",
                  vm: self,
                });
              }
            })
            .catch((error) => {});
        }
      } else {
        let self = this;
        this.$swal({
          title: "Copiar o Reprogramar",
          text: "Elija una opción. Si desea salir apriete la X",
          icon: "success",
          showCancelButton: true,
          showDenyButton: true,
          showCloseButton: true,
          confirmButtonColor: "orange",
          cancelButtonColor: "purple",
          confirmButtonText: "Copiar",
          cancelButtonText: "Reprogramar",
          denyButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            const datosTurno = {
              idTurno: this.itemCopia.idTurno,
              idProfesional: this.prof,
              horaTurno: item.hora,
              diaTurno: this.dateFormatted,
              cantIntervalos: this.itemCopia.cantIntervalos,
              tiempoTurno: this.itemCopia.tiempoTurno,
              usuarioAlta: this.$store.state.usuario.usuario,
            };
            axios
              .get("/Turnos/CopiarTurno", {
                params: {
                  idTurno: datosTurno.idTurno,
                  idProfesional: datosTurno.idProfesional,
                  horaTurno: datosTurno.horaTurno,
                  fechaTurno: datosTurno.diaTurno,
                  cantIntervalos: datosTurno.cantIntervalos,
                  tiempoTurno: datosTurno.tiempoTurno,
                  usuarioAlta: datosTurno.usuarioAlta,
                },
              })
              .then((response) => {
                if (response.data == "Reservado") {
                  self.showAlert({
                    icon: "error",
                    title:
                      "Disculpe, el turno acaba de ser tomado. Reserve otro por favor",
                    vm: self,
                  });
                  self.armarTurnos();
                  return;
                }
                if (response.data == "Turnos Existentes") {
                  self.showAlert({
                    icon: "error",
                    title:
                      "Existen turnos ya reservados dentro de la duración del turno que quiere reservar",
                    vm: self,
                  });
                } else {
                  self.showAlert({
                    icon: "success",
                    title: "Turno copiado exitosamente",
                    vm: self,
                  });
                  self.armarTurnos();
                  self.cancelaCopia();
                }
              })
              .catch((error) => {
                self.showAlert({
                  icon: "error",
                  title: "El turno no pudo ser copiado",
                  vm: self,
                });
              });
          } else {
            if (result.dismiss == "cancel") {
              if (this.itemCopia.idProfesional === 1869 && this.itemCopia.estadoTurno !== 2) {
                self.$swal.fire({
                  icon: "error",
                  title: "El paciente debe ser recepcionado antes de poder ser atendido.",
                  showConfirmButton: true,
                  background: "#ececec",
                });
                self.cancelaCopia();
                return;
              }
              const datosTurno = {
                idTurno: this.itemCopia.idTurno,
                idProfesional: this.prof,
                horaTurno: item.hora,
                diaTurno: this.dateFormatted,
                cantIntervalos: this.itemCopia.cantIntervalos,
                tiempoTurno: this.itemCopia.tiempoTurno,
                usuarioModi: this.$store.state.usuario.usuario,
                profesionalOriginal: this.itemCopia.idProfesional,
              };
              axios
                .get("/Turnos/ReprogramarTurno", {
                  params: {
                    idTurno: datosTurno.idTurno,
                    idProfesional: datosTurno.idProfesional,
                    horaTurno: datosTurno.horaTurno,
                    fechaTurno: datosTurno.diaTurno,
                    cantIntervalos: datosTurno.cantIntervalos,
                    tiempoTurno: datosTurno.tiempoTurno,
                    usuarioModi: datosTurno.usuarioModi,
                    profesionalOriginal: datosTurno.profesionalOriginal,
                  },
                })
                .then((response) => {
                  if (response.data == "Reprogramado") {
                    self.showAlert({
                      icon: "error",
                      title:
                        "Disculpe, el turno acaba de ser reprogramado por otro profesional",
                      vm: self,
                    });
                    self.armarTurnos();
                    return;
                  }

                  if (response.data == "Reservado") {
                    self.showAlert({
                      icon: "error",
                      title:
                        "Disculpe, el turno acaba de ser tomado. Reserve otro por favor",
                      vm: self,
                    });
                    self.armarTurnos();
                    return;
                  }
                  if (response.data == "Turnos Existentes") {
                    self.showAlert({
                      icon: "error",
                      title:
                        "Existen turnos ya reservados dentro de la duración del turno que quiere reservar",
                      vm: self,
                    });
                  } else {
                    self.showAlert({
                      icon: "success",
                      title: "Turno reprogramado exitosamente",
                      vm: self,
                    });
                    self.armarTurnos();
                    self.cancelaCopia();
                  }
                })
                .catch((error) => {
                  self.showAlert({
                    icon: "error",
                    title: "El turno no pudo ser reprogramado",
                    vm: self,
                  });
                });
            }
          }
        });
      }
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2500,
      });
    },
    mostrarColores() {
      this.showColores = true;
    },
    mostrarCronogramas() {
      this.showCronogramas = true;
    },
    verConsultorio() {
      this.showVerConsultorio = true;
    },
    calcularHora(hora) {
      var division = hora.split(":");
      var hoy = new Date();
      var fecha = new Date(
        hoy.getYear(),
        hoy.getMonth(),
        hoy.getDay(),
        division[0],
        parseInt(division[1] - 1),
      );
      var minutos = fecha.getMinutes().toString();
      if (minutos.length == 1) minutos = "0" + minutos;
      var horaNueva = fecha.getHours() + ":" + minutos;
      return horaNueva;
    },
    horaAMinutos(hora) {
      if (!hora) return null;
      const partes = hora.toString().substring(0, 5).split(":");
      if (partes.length < 2) return null;
      return parseInt(partes[0], 10) * 60 + parseInt(partes[1], 10);
    },
    minutosAHora(min) {
      const h = Math.floor(min / 60);
      const m = min % 60;
      return (h < 10 ? "0" + h : "" + h) + ":" + (m < 10 ? "0" + m : "" + m);
    },
    // A partir del turno base, busca la cadena de entreturnos en minutos
    // consecutivos hacia atrás y devuelve el último ocupado y la próxima hora libre.
    obtenerUltimoEntreTurno(horaBaseTurno) {
      const lista = this.listaTurnos || [];
      const baseMin = this.horaAMinutos(horaBaseTurno);
      if (baseMin === null) return null;

      const ocupados = new Set(
        lista.map((t) => this.horaAMinutos(t.hora)).filter((m) => m !== null),
      );

      let candidato = baseMin - 1;
      let ultimoOcupado = null;
      while (ocupados.has(candidato)) {
        ultimoOcupado = candidato;
        candidato -= 1;
      }

      if (ultimoOcupado === null) return null;
      return {
        ultimaHora: this.minutosAHora(ultimoOcupado),
        proximaHoraLibre: this.minutosAHora(ultimoOcupado - 1),
      };
    },
    deleteItem(item) {
      this.$swal({
        title: "Borrar Turno",
        text: "¿Desea borrar el turno?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idTurno = item.idTurno;
          this.$loading(true);
          let self = this;
          axios
            .get("/Turnos/BorrarTurno?", {
              params: {
                idTurno: idTurno,
                usuario: this.$store.state.usuario.usuario,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Turno borrado",
                vm: self,
              });
              setTimeout(self.armarTurnos(), 1700);
              self.$loading(false);
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El turno no pudo ser borrado",
                vm: this,
              });
              self.$loading(false);
            });
        }
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    async turnoRegistrado(datosTurno) {
      await this.armarTurnos();
      setTimeout(this.cerrarVentana, 600);

      if (datosTurno.cobra) {
        this.editedItem = {
          ...this.listaTurnos.find(
            (turno) => turno.idTurno === datosTurno.idTurno,
          ),
        };
        this.showNuevoCobro = true;
      }
    },
    cerrarVentana() {
      this.showNuevoTurno = false;
    },
    turnoModificado() {
      this.armarTurnos();
      setTimeout(this.cerrarVentanaModificar, 600);
    },
    cerrarVentanaModificar() {
      this.showEditarTurno = false;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },
    isMobile() {
      if (window.innerWidth < 992) {
        return true;
      } else {
        return false;
      }
    },
    llamarPaciente(item) {
      const datosLlamada = {
        nombreProfesional:
          this.$refs.vselect.selectedItems[0].nombreProfesional,
        idProfesional: this.prof,
        nombrePaciente: item.paciente,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        fechaTurno: this.dateFormatted,
        horaTurno: item.hora.toString().substr(0, 5),
      };
      let self = this;
      axios
        .get("/Turnos/LlamarPaciente?", {
          params: {
            nombreProfesional: datosLlamada.nombreProfesional,
            idProfesional: datosLlamada.idProfesional,
            nombrePaciente: datosLlamada.nombrePaciente,
            idInstitucion: datosLlamada.idInstitucion,
            fechaTurno: datosLlamada.fechaTurno,
            horaTurno: datosLlamada.horaTurno,
          },
        })
        .then((response) => {
          if (response.data == "Ok") {
            self.showAlert({
              icon: "success",
              title:
                "El paciente " + item.paciente + " fue llamado correctamente",
              vm: this,
            });
          }
        })
        .catch((error) => {
          self.showAlert({
            icon: "error",
            title: "El paciente no pudo ser llamado",
            vm: this,
          });
        });
    },
    llamarSecretaria() {
      const datosLlamada = {
        nombreProfesional:
          this.$refs.vselect.selectedItems[0].nombreProfesional,
        idProfesional: this.prof,
        nombrePaciente: "SECRETARIA",
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Turnos/LlamarSecretaria?", {
          params: {
            nombreProfesional: datosLlamada.nombreProfesional,
            idProfesional: datosLlamada.idProfesional,
            nombrePaciente: datosLlamada.nombrePaciente,
            idInstitucion: datosLlamada.idInstitucion,
          },
        })
        .then((response) => {
          if (response.data == "Ok") {
            self.showAlert({
              icon: "success",
              title: "La secretaria fue llamada correctamente",
              vm: this,
            });
          }
        })
        .catch((error) => {
          self.showAlert({
            icon: "error",
            title: "La secretaria no pudo ser llamada",
            vm: this,
          });
        });
    },
  },
  components: {
    EditarTurno,
    NuevoTurno,
    Colores,
    VerCronogramas,
    NuevoCobro,
    VerPacientesEnEspera,
    VerConsultorio,
  },
};
</script>
